const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Intro = () => import('~/pages/intro/intro').then(m => m.default || m)
const Personal = () => import('~/pages/intro/personal').then(m => m.default || m)
const CharSelect = () => import('~/pages/intro/char_select').then(m => m.default || m)

const Spent = () => import('~/pages/spent/spent').then(m => m.default || m)

const Dashboard = () => import('~/pages/dashboard/dashboard').then(m => m.default || m)

const TestRelatie = () => import('~/pages/zelftests/relatie').then(m => m.default || m)
const TestVel = () => import('~/pages/zelftests/vel').then(m => m.default || m)
const TestLichaamsbeeld = () => import('~/pages/zelftests/lichaamsbeeld').then(m => m.default || m)

const IGLore = () => import('~/pages/instagram/lore').then(m => m.default || m)
const IGMarthe = () => import('~/pages/instagram/marthe').then(m => m.default || m)
const IGAmina = () => import('~/pages/instagram/amina').then(m => m.default || m)
const IGSolange = () => import('~/pages/instagram/solange').then(m => m.default || m)

const IGLaure = () => import('~/pages/instagram/laure').then(m => m.default || m)
const IGMila = () => import('~/pages/instagram/mila').then(m => m.default || m)
const IGAminaFr = () => import('~/pages/instagram/amina_fr').then(m => m.default || m)
const IGSolangeFr = () => import('~/pages/instagram/solange_fr').then(m => m.default || m)

const IGkimmeluus_xx = () => import('~/pages/instagram/kimmeluus_xx').then(m => m.default || m)
const IGchicaa_xx = () => import('~/pages/instagram/chicaa_xx').then(m => m.default || m)
const IGchar_is = () => import('~/pages/instagram/char_is').then(m => m.default || m)
const IGcha_is = () => import('~/pages/instagram/cha_is').then(m => m.default || m)
const IGmona_vh = () => import('~/pages/instagram/mona_vh').then(m => m.default || m)
const IGnadie = () => import('~/pages/instagram/nadie').then(m => m.default || m)
const IGnady = () => import('~/pages/instagram/nady').then(m => m.default || m)
const IGselyna002 = () => import('~/pages/instagram/selyna002').then(m => m.default || m)

const IGvolgzamevogelvvv = () => import('~/pages/instagram/volgzame_vogel_v_v_v').then(m => m.default || m)
const IGcolombedocilevvv = () => import('~/pages/instagram/colombe_docile_v_v_v').then(m => m.default || m)
const IGunicornfun = () => import('~/pages/instagram/unicorn_fun').then(m => m.default || m)
const IGlicornedreams = () => import('~/pages/instagram/licorne_dreams').then(m => m.default || m)
const IGminimaarmaxipret_xoxo = () => import('~/pages/instagram/minimaarmaxipret_xoxo').then(m => m.default || m)
const IGminimaxifun_xoxo = () => import('~/pages/instagram/minimaxifun_xoxo').then(m => m.default || m)
const IGfriendzoooone = () => import('~/pages/instagram/friendzoooone').then(m => m.default || m)
const IGglittergirl = () => import('~/pages/instagram/glittergirl').then(m => m.default || m)
const IGbulle_de_paillettes = () => import('~/pages/instagram/bulle_de_paillettes').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },

  { path: '*', component: NotFound },

  { path: '/intro', name: 'intro', component: Intro },
  { path: '/personal', name: 'personal', component: Personal },
  { path: '/char_select', name: 'char_select', component: CharSelect },

  { path: '/spent', name: 'spent', component: Spent },

  { path: '/dashboard', name: 'dashboard', component: Dashboard },

  { path: '/zelftests/relatie', name: 'testrelatie', component: TestRelatie },
  { path: '/zelftests/vel', name: 'testvel', component: TestVel },
  { path: '/zelftests/lichaamsbeeld', name: 'testlichaamsbeeld', component: TestLichaamsbeeld },

  { path: '/instagram/lore', name: 'lore', component: IGLore },
  { path: '/instagram/marthe', name: 'marthe', component: IGMarthe },
  { path: '/instagram/amina', name: 'amina', component: IGAmina },
  { path: '/instagram/solange', name: 'solange', component: IGSolange },

  { path: '/instagram/laure', name: 'lore', component: IGLaure },
  { path: '/instagram/mila', name: 'marthe', component: IGMila },
  { path: '/instagram/amina_fr', name: 'amina', component: IGAminaFr },
  { path: '/instagram/solange_fr', name: 'solange', component: IGSolangeFr },

  { path: '/instagram/kimmeluus_xx', name: 'igkimmeluus_xx', component: IGkimmeluus_xx },
  { path: '/instagram/chicaa_xx', name: 'chicaa_xx', component: IGchicaa_xx },
  { path: '/instagram/char_is', name: 'char_is', component: IGchar_is },
  { path: '/instagram/cha_is', name: 'cha_is', component: IGcha_is },
  { path: '/instagram/mona_vh', name: 'mona_vh', component: IGmona_vh },
  { path: '/instagram/nadie', name: 'nadie', component: IGnadie },
  { path: '/instagram/nady', name: 'nady', component: IGnady },
  { path: '/instagram/selyna002', name: 'selyna002', component: IGselyna002 },

  { path: '/instagram/volgzame_vogel_v_v_v', name: 'volgzamevogelvvv', component: IGvolgzamevogelvvv },
  { path: '/instagram/colombe_docile_v_v_v', name: 'colombedocilevvv', component: IGcolombedocilevvv },
  { path: '/instagram/unicorn_fun', name: 'unicorn_fun', component: IGunicornfun },
  { path: '/instagram/licorne_dreams', name: 'licorne_dreams', component: IGlicornedreams },
  { path: '/instagram/minimaarmaxipret_xoxo', name: 'minimaarmaxipret_xoxo', component: IGminimaarmaxipret_xoxo },
  { path: '/instagram/minimaxifun_xoxo', name: 'minimaxifun_xoxo', component: IGminimaxifun_xoxo },
  { path: '/instagram/friendzoooone', name: 'friendzoooone', component: IGfriendzoooone },
  { path: '/instagram/glittergirl', name: 'glittergirl', component: IGglittergirl },
  { path: '/instagram/bulle_de_paillettes', name: 'bulle_de_paillettes', component: IGbulle_de_paillettes }

]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js